import { Button, Col } from 'antd';
import React, { ReactElement } from 'react';
import { useDispatch } from 'react-redux';
import { setIsMinimize, toggleFileUploadByForce } from '../../../../../store/actions/newAdmissionAction';

const HeaderRightAction = (props: any): ReactElement => {
  const dispatch = useDispatch();

  const openModal = (): void => {
    props.form.validateFields().then((): any => {
    dispatch(toggleFileUploadByForce(true));
    dispatch(setIsMinimize(false));
    });
  };
  return (<>
  {props.isShowAdmissionForm &&
    <Col className="text-right">
      <Button
        data-testid="submit-new-admission"
        type="primary"
        className="btn-primary"
        onClick={openModal}
        htmlType={'submit'}
      >
        Upload Documents
      </Button>
    </Col>
}
  </>);
};

export default HeaderRightAction;
